import React from 'react';
import { RaisedButton, IconButton } from 'material-ui';
import { connect } from 'react-redux';
import Exit from 'material-ui/svg-icons/action/exit-to-app';
import { commitMutation, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';

import OurismanTravelTheme from '../../ourismanTravelTheme';
import * as AuthActions from '../../store/actions/AuthActions';
import environment from '../../relay/environment';

@connect(state => ({
  authenticated: state.Auth.get('authenticated'),
}))
class LogoutButton extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    authenticated: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  logOut = (input) => {
    commitMutation(
      environment,
      {
        mutation: graphql`
          mutation LogoutButton_LogOut_Mutation (
            $input: LogOutInput!
          ) {
            logOut(input: $input) {
              token {
                token
              }
            }
          }
        `,
        variables: { input },
        onCompleted: () => {
          this.props.dispatch(AuthActions.logout());
        },
        onError: err => alert(err),
      }
    );
  }

  handleClick = () => {
    this.props.dispatch(AuthActions.logout());
  };

  render() {
    const { authenticated } = this.props;

    return (<div>
      <div className={css(styles.large)}>
        <RaisedButton
          label='Logout'
          primary
          onClick={this.handleClick}
          icon={<Exit />}
          disabled={!authenticated}
        />
      </div>
      <div className={css(styles.small)}>
        <IconButton
          onClick={this.handleClick}
          disabled={!authenticated}
        >
          {<Exit color={OurismanTravelTheme.palette.alternateTextColor} />}
        </IconButton>
      </div>
    </div>);
  }
}

const styles = StyleSheet.create({
  large: {
    '@media (max-width: 800px)': {
      display: 'none',
    },
  },
  small: {
    '@media (min-width: 800px)': {
      display: 'none',
    },
  },
});

export default LogoutButton;



// WEBPACK FOOTER //
// /src/components/Container/LogoutButton.js